import * as React from "react";

import { renderToggleButton_unstable } from "@fluentui/react-components";

import type { RibbonToggleButtonInternalProps } from "../RibbonToggleButton.props";
import { useRibbonToggleButton } from "./useRibbonToggleButton";
import { useRibbonToggleButtonStyles } from "./useRibbonToggleButtonStyles.styles";
import type { RibbonToggleButtonProps } from "./RibbonToggleButton.types";
import { AppTooltipContainer } from "@1js/acui-tooltip";

export const RibbonToggleButton = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonToggleButtonInternalProps>(
    (props, ref) => {
      const state = useRibbonToggleButton(
        {
          ...props,
          size: props.size?.toLowerCase() as RibbonToggleButtonProps["size"],
        } as RibbonToggleButtonProps,
        ref
      );

      useRibbonToggleButtonStyles(state);

      return (
        <AppTooltipContainer {...props}>
          {renderToggleButton_unstable(state)}
        </AppTooltipContainer>
      );
    }
  )
);

RibbonToggleButton.displayName = "next/RibbonToggleButton";
